import { createContext, useContext, useEffect, useState } from "react";
import { useSocketContext } from "./socketContext";
import {
	getOpenChatCount,
	getSessionValue,
	setSessionValue,
	loadContactsData,
	logoutUser,
	menuRefresh,
	parseJSON,
	constructEmitStr
} from "../../../Common/Appcommon";

const UsersContext = createContext();

const useUsersContext = () => useContext(UsersContext);

const UsersProvider = ({ children }) => {
	const socket = useSocketContext();
	const sessionappid = getSessionValue('appid');
	const [users, setUsers] = useState({});
	const [userId, setUserId] = useState("");
	const [msgUserId, setMsgUserId] = useState("");

	const _updateUserProp = (userId, prop, value) => {
		setUsers((users) => {
			const usersCopy = [...users];
			let userIndex = users.findIndex((user) => user.cid === userId);
			const userObject = usersCopy[userIndex];
			usersCopy[userIndex] = { ...userObject, [prop]: value };
			return usersCopy;
		});
	};
	const loadUsers = (users) => {
		setUsers(users);
	};
	const setUserAsTyping = (data) => {
		const { userId } = data;
		_updateUserProp(userId, "typing", true);
	};

	const setUserAsNotTyping = (data) => {
		const { userId } = data;
		_updateUserProp(userId, "typing", false);
	};

	const fetchMessageResponse = (data) => {
		setUsers((users) => {
			const { userId, response } = data;

			let userIndex = users.findIndex((user) => user.id === userId);
			const usersCopy = parseJSON(JSON.stringify(users));
			const newMsgObject = {
				content: response,
				sender: userId,
				time: new Date().toLocaleTimeString(),
				status: null,
			};

			usersCopy[userIndex].messages.TODAY.push(newMsgObject);

			return usersCopy;
		});
	};

	const refreshContacts = async (data) => {
		const curURL = window.location.href;
		if(curURL.includes(`/#/inbox`)){
			let {appid, userid} = data;
			setMsgUserId(userid);
			if(appid === sessionappid) {
				let inboxUserID = getSessionValue('inboxUserID');
				setSessionValue('isRefreshContacts', true);
				let filterOptions = getSessionValue('FILTEROPTION');
				let cid = "";
				if(filterOptions !== ""){
					filterOptions = parseJSON(filterOptions);
				}
				if(inboxUserID === userid){
					cid = userid;
				}
				let response = await loadContactsData(filterOptions, 1, 200, "Webhook", cid);
				if (response.issuccess) {
					let contacts = response.data;
					loadUsers(contacts);
					getOpenChatCount(contacts);
				}
			}
		}
	}

	useEffect(() => {
		let loginUserId = getSessionValue('loginuserid');
		if(socket !== undefined){
			socket.on("fetch_response", fetchMessageResponse);
			socket.on("start_typing", setUserAsTyping);
			socket.on("stop_typing", setUserAsNotTyping);
			console.log("Socket Register: ",constructEmitStr(sessionappid, loginUserId, "refresh_contacts"));
			socket.on(constructEmitStr(sessionappid, loginUserId, "refresh_contacts"), refreshContacts);
			socket.on(constructEmitStr(sessionappid, "", "wplogout"), logoutUser);
			//socket.on("menuRefresh", menuRefresh);
			//socket.on("test_socket", testingSocket);
		}
	}, [socket]);

	const testingSocket = () => {
		console.log("Response from Server");
	}

	const setUserAsUnread = (userId) => {
		_updateUserProp(userId, "unread", 0);
		_updateUserProp(userId, "wsapp_unread_count", 0);
	};

	const addNewMessage = (userId, message) => {
		console.log("Emitting Socket");
		socket.emit("test_socket", {  });
		/*
		let userIndex = users.findIndex((user) => user.id === userId);
		const usersCopy = [...users];
		const newMsgObject = {
			content: message,
			sender: null,
			time: new Date().toLocaleTimeString(),
			status: "delivered",
		};
        console.log("addNewMessage userid-----"+userId);
        console.log("addNewMessage message-----"+message);
		usersCopy[userIndex].messages.TODAY.push(newMsgObject);
		setUsers(usersCopy);
		socket.emit("fetch_response", { userId });*/
	};
	const setCurrentContactUser = (userId) => {
		setUserId(userId);
	};
	const getCurrentContact = () => {
		return userId;
	};

	return (
		<UsersContext.Provider value={{ users,setUserAsUnread,addNewMessage,loadUsers,setCurrentContactUser,getCurrentContact,msgUserId,refreshContacts}}>
			{children}
		</UsersContext.Provider>
	);
};

export { useUsersContext, UsersProvider };
